import { Container, Header, Modal, Segment, Icon, Transition } from 'semantic-ui-react'
import { Text } from 'preact-i18n'
import { useStore } from '../../store'

const LicenseErrorModal = () => {
  const store = useStore()
  const open = store.errorsStore.hasLicenseError.value
  return (
    <Transition visible={open} animation="scale" duration={600} unmountOnHide>
      <Modal id="license-error-modal" basic open={true} style={{ justifyContent: 'center' }}>
        <Container textAlign="center">
          <Modal.Header>
            <Segment inverted>
              <Header icon>
                <Icon name="warning sign" size="huge" />
                <Text id="errors.license.title" />
              </Header>
            </Segment>
          </Modal.Header>
          <Modal.Content>
            <Segment inverted>
              <p>
                <Text id="errors.license.message" />
              </p>
              <p>{store.errorsStore.licenseError.value}</p>
            </Segment>
          </Modal.Content>
        </Container>
      </Modal>
    </Transition>
  )
}
export default LicenseErrorModal
